module.exports = publishpressFutureSettingsConfig;